import React, { Fragment } from 'react';

export default class Hideable extends React.Component{
  constructor(props){
    super(props);
    this.heightDefault = null;
  }
  // ____________________________________________________________________

  //SearchErrがある場合、自動隠ししません
  //EDIのみの仕様
  shouldComponentUpdate(nextProps,nextStates){
    if(nextProps.hidden != this.props.hidden){
       this.heightDefault=this.wrapRef.getBoundingClientRect().height
       this.hiddenAction(nextProps.hidden);
       return true;
     }
     return false
  }

  hiddenAction=(hidden)=>{                               // ボタンをクリックしたとき
    if(!hidden){                     // -中身が隠されているとき
      setTimeout(()=>{                        // --中身がすべて見えてから処理を行うように、時間差で処理を行う。
        this.processing = false;              // 処理が終わったことを明示しています。（ボックスが閉じている途中にクリックしたらスタイルが崩れるので）
      },this.props.speed? this.props.speed * 1000 : 500)　            // --speed を親から指定できるように
    }else{                                    　// -中身が見えているとき　(閉じるアクション開始)
      if( this.processing === true ) { return; }       　//  閉じるアクションが働いている時は処理をはじきます
      setTimeout(()=>{                        // --中身がすべて見えてから処理を行うように、時間差で処理を行う。
        this.processing = true;              // 処理が終わったことを明示しています。（ボックスが閉じている途中にクリックしたらスタイルが崩れるので）
      },this.props.speed? this.props.speed * 1000 : 500)　            // --speed を親から指定できるように
    }
  }

  render(){

    const hidden = {
      transition:this.props.speed? this.props.speed + "s" : "0.5s",    // speed を親から指定できるように
      height: this.props.hidden? 0:this.heightDefault,
      overflow: this.props.hidden?"hidden":null ,
      opacity:this.props.hidden? 0:null,
    }

    return(
      <Fragment>
      <div style={ hidden }>
        <div  
          ref       = { (e)=> this.wrapRef = e}
          style     = { this.props.style }
          className = { this.props.className }
        >
          {this.props.children}
        </div>
      </div>
      </Fragment>
    )
  }
}